import React from 'react'
import styled from 'styled-components'
import Snackbar from '@material-ui/core/Snackbar'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Alert from 'src/components/Alert'
import { connectSnackbar } from 'src/ducks/connectors'
import { isEmpty } from 'ramda'
import themeData from 'src/theme/theme'

const useStyles = makeStyles({
  root: {
    top: `calc(${themeData.dimensions.topBarHeight} + 8px)`,
    zIndex: 10000
  }
})

// The API leaves the "now" date-rule parameter untranslated in Polish errors.
const formatValidationMessage = message =>
  typeof message === 'string'
    ? message.replace(
        /musi być datą późniejszą niż now(?=\.?(?:\s|$))/g,
        'musi wskazywać termin w przyszłości'
      )
    : message

const GlobalSnackbar = ({
  snackbar: { open, type, message, title },
  setSnackbar,
  className
}) => {
  const classes = useStyles()

  return (
    <Snackbar
      classes={{ root: classes.root }}
      open={open}
      onClose={() => setSnackbar({ open: false })}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      {!isEmpty(message) && (
        <Alert
          type={type}
          message={formatValidationMessage(message)}
          className={className}
          size={28}
          title={formatValidationMessage(title)}
        />
      )}
    </Snackbar>
  )
}
const ConnectedComponent = connectSnackbar(GlobalSnackbar)

export default styled(ConnectedComponent)`
  box-shadow: 0 0 20px 0 rgba(36, 45, 63, 0.24);
  border: 1px solid ${({ theme }) => theme.colors.outerSpace.alpha(0.4).hex()};
  min-width: 290px;
  min-height: 65px;
  font-size: 0.9rem;
  font-weight: 500;
`
